import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  i18n,
  RootState,
  setExamDraft,
  setProgressBarPercentage,
  SoHealthAdditionalInfo,
  useAppDispatch,
  useAppSelector
} from 'src/common';
import { ArrowRightIcon, BackLink, Button, Card, emptyHealthExams, Flex, HealthExamsForm, Text, validateHealthExams } from 'src/components';
import { colors } from 'src/theme';
import { AppRoutesAdditional, AppRoutesAdditionalCrossell } from '../../_router/app.routes';

const HealthExamsPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isCrossell = pathname.includes('dodatno-zdravstveno-osiguranje-crossell');
  const routes = isCrossell ? AppRoutesAdditionalCrossell : AppRoutesAdditional;
  const draft = useAppSelector((state: RootState) => state.model.exam.data);

  useEffect(() => {
    dispatch(setProgressBarPercentage(15));
  }, []);

  const [exams, setExams] = useState<SoHealthAdditionalInfo>(draft ?? emptyHealthExams);
  const [error, setError] = useState<string>('');

  const handleSubmit = () => {
    const validationError = validateHealthExams(exams);
    if (validationError) {
      setError(validationError);
      return;
    }
    setError('');
    dispatch(setExamDraft(exams));
    navigate(`${routes.CUSTOMER_DATA.fullPath}`);
  };

  return (
    <Flex vertical align="center" gap={32} >
      <Card>
        <Flex vertical gap={24}>
          <Text type="large" bold style={{ marginBottom: 32 }}>{i18n.t('pages.healthExams.title')}</Text>
          <HealthExamsForm value={exams} onChange={setExams} />

          <Flex vertical gap={8}>
            <Button
              onClick={handleSubmit}
              btnType="primary"
              size="large"
              text={i18n.t('pages.healthExams.submitButton', { defaultValue: 'Potvrdi odabir' })}
              className="btnBlock"
            >
              <ArrowRightIcon color={colors.white} />
            </Button>
            {error && (
              <Text type="small" color={colors.error1} style={{ textAlign: 'center' }}>
                {error}
              </Text>
            )}
          </Flex>


        </Flex>
      </Card>
      <Flex justify="center">
        <BackLink text={i18n.t('pages.healthExams.backLink')} path={routes.CUSTOMER_ONLY_DATE.fullPath} />
      </Flex>
    </Flex>
  );
};

export default HealthExamsPage;
